import { concat } from '@ember/helper';
import { PrismMetricBlock } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { DOMAIN_NAME } from 'frontend-utils/utils/constants/domain-utils';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';
import GeneralNotificationDot from 'lumen/components/general/notification-dot';

const HotelStrategySubtypeMetric = <template>
  {{! @glint-nocheck }}
  <PrismMetricBlock @align="left" class="w-1/2">
    <:value>
      <span
        class="strategy-value
          {{if @isOwnHotel 'strategy-value--own-hotel'}}
          text-400--bold"
      >
        {{#if @showNonComputableWarning}}
          <a
            data-event-id="hotel-rate-strategy-non-computable-icon-clicked"
            href={{concat
              "https://help."
              DOMAIN_NAME
              "/en/articles/5376608-what-does-this-icon-mean-in-rate-strategy"
            }}
            rel="noopener noreferrer"
            target="_blank"
          >
            <div class="ml-200">
              <GeneralIconWithTooltip
                @iconName="warning"
                @side="top"
                @size="medium"
                @tooltipContent={{t "strategy.warning.cannot_be_calculated"}}
              />
            </div>
          </a>
        {{else}}
          <h3 class="flex flex-row">
            {{@value}}
            {{#if @changeOverTime}}
              <GeneralNotificationDot />
            {{/if}}
          </h3>
        {{/if}}
      </span>
    </:value>
    <:label>
      <span class="text-200--medium">{{@label}}</span>
    </:label>
  </PrismMetricBlock>
</template>;

export default HotelStrategySubtypeMetric;
